module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av309-b3042cbec24c1dad1f1a0de9abaddce2.jpg";